import { useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import NsContent from 'components/common/ns-content/NsContent';

import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { ExpiringPsrList } from 'components/direct-sales/psr-capture/components/ExpiringPsrList';
import { PsrList } from 'components/direct-sales/psr-capture/components/PsrList';
import {
  selectCombinedPsr,
  selectExpiringPsrPreferences
} from 'state/psr/psr-slice';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsForm } from 'components/common/ns-form/NsForm';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsExpander } from 'components/common/ns-expander/NsExpander';
import { useNavigation } from 'hooks/useNavigation';

export const testId = 'psrCaptureTestId';

export const PsrCapture = () => {
  const psr = useSelector(selectCombinedPsr, shallowEqual);
  const expiringPsrPreferences = useSelector(
    selectExpiringPsrPreferences,
    shallowEqual
  );
  const { eventTypes, next } = useNavigation();

  const handleGoNext = useCallback(() => {
    next({ eventType: eventTypes.NEXT });
  }, [next, eventTypes.NEXT]);

  return (
    <NsPanel testId={testId}>
      <NsBackCta />
      <NsContent>
        <NsTitle title="Please tell us more" />

        <p>Please select every option that applies to your household</p>

        <NsExpander heading="Read our PSR Promise">
          <p>
            We’ve signed up to the Priority Services Register (PSR) Promise.
          </p>
          <p>
            This has been made by all participating energy companies in the UK.
            We’ll only share details about your personal situation as agreed
            with you so that our trusted partners can tailor their services to
            help you, and you’ll get extra support when you need it. We&#39;ll
            always follow privacy laws and your PSR information will never be
            used for marketing. Once you’ve joined we may contact you to make
            sure your details are accurate and up to date. If your situation
            changes, or you don’t want to be on the PSR anymore, just get in
            touch and we&#39;ll update your details.
          </p>
        </NsExpander>
      </NsContent>
      <NsForm onSubmit={handleGoNext}>
        <PsrList psr={psr} />
        <ExpiringPsrList psr={expiringPsrPreferences} />
        <NsPrimaryCta>Continue</NsPrimaryCta>
      </NsForm>
    </NsPanel>
  );
};

export default PsrCapture;
